import { render, staticRenderFns } from "./SliderSwitch.vue?vue&type=template&id=ba8aa3fa&scoped=true&"
import script from "./SliderSwitch.vue?vue&type=script&lang=js&"
export * from "./SliderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SliderSwitch.vue?vue&type=style&index=0&id=ba8aa3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8aa3fa",
  null
  
)

export default component.exports